import {
	REBRANDING,
} from '~/config';

/**
 * Navigation Migration Configuration
 *
 * Centralized configuration for navigation layout control using feature flags.
 * Determines default layout, toggle visibility, and toggle label based on REBRANDING.navbar feature flag.
 *
 * Feature Flag Behavior:
 * - REBRANDING.navbar === true: Old nav default on first login, toggle shown, preference persisted
 * - REBRANDING.navbar === false: Old navigation only, toggle hidden
 *
 * Environment Configuration:
 * - Staging/Dev: navbar: true (new navigation enabled)
 * - Production: navbar: false (old navigation only)
 */

export type NavigationLayout = 'old' | 'new';

export type MigrationConfig = {
	defaultLayout: NavigationLayout;
	persistLayoutPreference: boolean;
	showToggle: boolean;
	toggleLabel: string | null;
};

/**
 * Get navigation migration configuration based on REBRANDING.navbar feature flag
 *
 * @returns MigrationConfig object with layout, toggle visibility, and label
 */
export function getNavigationMigrationConfig(): MigrationConfig {
	const rebrandingNavbar = REBRANDING?.navbar;

	if (rebrandingNavbar === false) {
		// Feature flag disabled: Force old navigation, hide toggle
		return {
			defaultLayout: 'old',
			persistLayoutPreference: false,
			showToggle: false,
			toggleLabel: null,
		};
	}

	if (rebrandingNavbar === true) {
		// Feature flag enabled: Old nav default on first login, toggle visible, preference persisted
		return {
			defaultLayout: 'old',
			persistLayoutPreference: true,
			showToggle: true,
			toggleLabel: 'Old Navigation',
		};
	}

	// Fallback: If feature flag is undefined (shouldn't happen in production),
	// default to old navigation for safety
	return {
		defaultLayout: 'old',
		persistLayoutPreference: false,
		showToggle: false,
		toggleLabel: null,
	};
}
